import(/* webpackMode: "eager", webpackExports: ["CalendlyPopup"] */ "/vercel/path1/components/layout/CalendlyPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path1/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisqusComments"] */ "/vercel/path1/features/posts/components/DisqusComments.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
